import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import {
  CreateCompanyOrganisationalLevelRequest,
  CompanyOrganisationalLevelResponse,
} from '../../company.model';
import { nullIfBlank } from '@shared/utils/payload-utils';

@Component({
  selector: 'app-organisational-level-form',
  imports: [ReactiveFormsModule, ...SharedMaterialUIModule],
  templateUrl: './organisational-level-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganisationalLevelFormComponent {
  private readonly formBuilder = inject(FormBuilder);

  readonly initialValue = input<CompanyOrganisationalLevelResponse | null>(null);
  readonly companyId = input.required<string>();
  readonly saving = input(false);
  readonly submitted = output<CreateCompanyOrganisationalLevelRequest>();

  readonly levelForm = this.formBuilder.group({
    level: [0, [Validators.required, Validators.min(0)]],
    name: ['', Validators.required],
  });

  constructor() {
    effect(() => {
      const initialValue = this.initialValue();
      if (!initialValue) {
        this.levelForm.reset({ level: 0, name: '' });
        return;
      }

      this.levelForm.reset({
          level: initialValue.level,
          name: initialValue.name,
        });
    });
  }

  protected onSubmit(): void {
    if (this.levelForm.invalid) {
      this.levelForm.markAllAsTouched();
      return;
    }

    const { level, name } = this.levelForm.getRawValue();
    const request: CreateCompanyOrganisationalLevelRequest = {
      companyId: this.companyId(),
      level: Number(level),
      name: nullIfBlank(name),
    };

    this.submitted.emit(request);
  }
}